module.exports = __webpack_public_path__ + "img/shiyuanhui big (10).82ff6bae.jpg";